import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import IntegrationSyncDirection from "@mapmycustomers/shared/enum/integrations/IntegrationSyncDirection";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";

import FieldFilter from "@app/component/SelectColumnsPane/type/FieldFilter";

export const skipNonListViewFields: FieldFilter = (field) =>
  !field.hasFeature(FieldFeature.NON_LIST_VIEW);

export const skipNonExportFields: FieldFilter = (field) =>
  !field.hasFeature(FieldFeature.NON_EXPORT_VIEW);

export const skipSyncArchiveFields =
  (syncDirection?: IntegrationSyncDirection) => (field: IField) =>
    syncDirection === IntegrationSyncDirection.SERVICE_TO_MMC
      ? !field.hasFeature(FieldFeature.OUTGOING)
      : syncDirection === IntegrationSyncDirection.MMC_TO_SERVICE
      ? !field.hasFeature(FieldFeature.INCOMING)
      : true;
